// Single source of truth for Dorte's current availability.
// When her calendar opens up again, change only these two values.
export const BOOKED_UNTIL_YEAR = 2028;
export const EARLIEST_DATE = `${BOOKED_UNTIL_YEAR}-01-01`;
